module.exports = __webpack_public_path__ + "static/media/sales1.dc7f8d74.avif";